// cart-url.js — rewritten for URL-param-driven pre-checkout page

function getUrlParameter(name, defaultValue = null) {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(name);
  if (!value) {
    console.warn(`Parameter "${name}" not found in URL.`);
    return defaultValue;
  }
  return value;
}

function getItemsFromUrl() {
  const raw = getUrlParameter('items');
  if (!raw) return [];
  try {
    return JSON.parse(atob(raw));
  } catch (e) {
    console.error('Failed to decode items param:', e);
    return [];
  }
}

function formatPrice(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

document.addEventListener('DOMContentLoaded', function () {
  const isEditor = window.Shopify?.designMode || window.self !== window.top;
  const checkoutUrl = getUrlParameter('checkout_url');
  const priceParam = parseInt(getUrlParameter('price', '0'));
  const items = getItemsFromUrl();

  if (!checkoutUrl) {
    console.warn('No checkout_url param — skipping redirect in dev/editor context');
  return;
  }

  document.querySelectorAll('[data-checkout-btn], .cta-button, .checkout-button').forEach(btn => {
    if (checkoutUrl) btn.href = checkoutUrl;
  });

  if (priceParam > 0) {
    const monthly = formatPrice(priceParam);
    const perDay = formatPrice(Math.round(priceParam / 30));
    document.querySelectorAll('[data-monthly-price]').forEach(el => el.textContent = monthly);
    document.querySelectorAll('[data-daily-price]').forEach(el => el.textContent = perDay);
  }

  const container = document.querySelector('[data-product-list], .product-list, .items-container');
  if (container && items.length > 0) {
    container.innerHTML = items.map((item, i) => `
      <div class="product-item">
        <span class="item-number">${String(i + 1).padStart(2, '0')}</span>
        <img src="${item.image}" alt="${item.title}" loading="lazy">
        <div class="item-info">
          <strong>${item.title}</strong>
          <p>${item.shortDescription}</p>
        </div>
        <div class="item-meta">
          <span class="item-volume">${item.quantity} × ${item.volume}</span>
          ${item.liposomal ? '<span class="liposomal-badge">✓ LIPOSOMAL</span>' : ''}
        </div>
      </div>
    `).join('');
  }
});
